import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/user-workflows/{userWorkflowId}/submit-case';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

/**
 * POST a PACER e-filing submission through the noodle-api orchestrator.
 *
 * Disables `axios-retry` for this single call: the orchestrator forwards to us-government-integrations
 * which performs a non-idempotent PACER submission. A frontend-driven retry on 502/504 could double-file
 * the case at PACER if the first attempt already reached us-gov but the response was lost. The user can
 * retry manually via the modal (which now stays open on error).
 */
const submitCase = async ({ userWorkflowId, ...body }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { userWorkflowId });
  const response = await noodleApiClient.post(path, body, { 'axios-retry': { retries: 0 } });
  return response.data;
};

export default submitCase;
